var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VinCard',{staticClass:"relative h-full",staticStyle:{"minHeight":"358px","paddingTop":"6px"}},[(_vm.showLoadingBlock)?_c('VinLoadingBlock',{staticClass:"z-20"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }